import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { RootStoreState, DbActions } from './root-store';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';

  constructor(private store: Store<RootStoreState.State>) {}

  ngOnInit(): void {
    this.store.dispatch(new DbActions.CheckDbBootstrap());
  }
}
